import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import TipTheDJ from "../views/TipView.vue";
import TipOverlay from "../views/TipOverlay.vue";
import PageNotFound from "../views/PageNotFound.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/tip/:sessionID?",
    name: "tip",
    component: TipTheDJ,
  },
  {
    path: "/tipOverlay",
    name: "tipOverlay",
    component: TipOverlay,
    meta: {
      hideHeaderFooter: true,
    },
  },
  {
    path: "/:pathMatch(.*)*",
    component: PageNotFound,
    name: "PageNotFound",
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return { el: to.hash };
    }
  },
});

export default router;
